import React from 'react'

function SeoService() {
  return (
    <div>SeoService</div>
  )
}

export default SeoService